import { generatePath, PathParam } from 'react-router-dom';
import { RoutePath } from '@/shared/lib/ts-router';

export const appGeneratePath = <Path extends RoutePath>(
  path: Path,
  params?: {
    [key in PathParam<Path>]: string | null;
  },
) => {
  const resolvedPath = generatePath(path, params);

  return resolvedPath;
};
